import { useQuery } from 'react-query';

import { useApi } from '../../context/ApiContext';

export const useGetKamListForKam = () => {
  const client = useApi();

  return useQuery('get-list-transfers-account', () => client.get('/multiaccess/kam/kamList').then((res) => res.data));
};
